import { MarkdownContent } from './markdown-content';
import { AgentMessageLayout } from './agent-message-layout';

interface AgentMessageProps {
  content: string;
}

export function AgentMessage({ content }: AgentMessageProps) {
  return (
    <AgentMessageLayout>
      <MarkdownContent content={content} />
    </AgentMessageLayout>
  );
}
